import { clsx } from 'clsx';
import { type FC } from 'react';

import styles from './MapPin.css';

export interface IMapPinProps {
  theme: 'default' | 'plus';
}

export const MapPin: FC<IMapPinProps> = props => {
  const { theme } = props;
  const themeStyle = theme === 'default' ? styles['pin-default'] : styles['pin-plus'];

  return <span className={clsx(styles['pin'], themeStyle)} />;
};
